import { ColDef } from 'ag-grid-community';

import {
  EDITABLE_FIELD_CONDITIONS,
  OBLIGATION_NOL_VALUES,
  OBLIGATION_STATE_PRE_POST_VALUES,
  ScenarioCompareReportData,
  ScenarioReportData,
  ScenarioReportsData,
  HIDDEN_FIELD_CONDITIONS,
} from './types';
import { YesNoFlag } from '../../shared/types';
import { uniq } from '../../shared/uniq';


export const getCellElementId = (colId: ColDef['colId'], rowIndex: number | null) => `${colId}-${rowIndex}`;

export const getPopupRootElemRef = (colId: ColDef['colId'], rowIndex: number) => document.getElementById(getCellElementId(colId, rowIndex));

export const getCellElementToElevateSelector = (colId: ColDef['colId'], rowIndex: number) => `.ag-body-viewport [row-index="${rowIndex}"] [col-id="${colId}"]`;

const verifyEditableConditions: Record<
  EDITABLE_FIELD_CONDITIONS,
  (data: ScenarioReportData | ScenarioCompareReportData) => boolean
  > = {
    [EDITABLE_FIELD_CONDITIONS.OBLIGATION_NOL_RECORD]: reportData =>
      reportData.OBLIGATION_NOL === OBLIGATION_NOL_VALUES.RECORD,

    [EDITABLE_FIELD_CONDITIONS.OBLIGATION_NOL_UTILIZE]: reportData =>
      reportData.OBLIGATION_NOL === OBLIGATION_NOL_VALUES.UTILIZE,

    [EDITABLE_FIELD_CONDITIONS.OBLIGATION_STATE_PRE_NOL]: reportData =>
      reportData.OBLIGATION_STATE_PRE_POST_NOL === OBLIGATION_STATE_PRE_POST_VALUES.PRE,

    [EDITABLE_FIELD_CONDITIONS.OBLIGATION_STATE_POST_NOL]: reportData =>
      reportData.OBLIGATION_STATE_PRE_POST_NOL === OBLIGATION_STATE_PRE_POST_VALUES.POST,
  };

export const verifyEditableCondition = (
  conditions: EDITABLE_FIELD_CONDITIONS[],
  reportData: ScenarioReportData | ScenarioCompareReportData
) =>
  conditions.every(condition => {
    if (condition in verifyEditableConditions) {
      return verifyEditableConditions[condition](reportData);
    }
    return false;
  });

const verifyVisibleConditions: Record<
  HIDDEN_FIELD_CONDITIONS,
  (data: ScenarioReportData | ScenarioCompareReportData) => boolean
  > = {
    [HIDDEN_FIELD_CONDITIONS.COMPANY_CODE_STAT_CALC_DISABLED]: reportData =>
      reportData.COMPANY_CODE_STAT_CALC === YesNoFlag.N,
  };

export const verifyHiddenCondition = (
  conditions: HIDDEN_FIELD_CONDITIONS[],
  reportData: ScenarioReportData | ScenarioCompareReportData
) =>
  conditions.every(condition => {
    if (condition in verifyVisibleConditions) {
      return verifyVisibleConditions[condition](reportData);
    }
    return false;
  });

export const getUniqCurrencies = (
  reportsData: undefined | ScenarioReportsData = {}
) => {
  const allReports = Object.values(reportsData).flat();

  return uniq(allReports.map(({ FUNCTIONAL_CURRENCY }) => FUNCTIONAL_CURRENCY));
};

export const valueExists = (value: any) => Boolean(value || value === 0);
